import "./i18n";
import { locale, addLocale } from 'primereact/api';
import 'moment/locale/pt-br';
import "antd/dist/antd.min.css";
import { ThemeProvider } from "styled-components";
import { lightTheme, darkTheme } from "./theme/theme";
import GlobalStyle from "./theme/globalStyle";
import Routes from "./routes";
import { useContext } from "react";
import SystemContext from "./context/systemContext/context";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import { NotificationProvider } from "./hooks/useNotifications";

import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
// import "primeicons/primeicons.css"; //icons

function App() {
  const { systemConfig, update } = useContext(SystemContext)
  const { i18n } = useTranslation();

  addLocale('pt-BR', {
    firstDayOfWeek: 1,
    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Quar', 'Quin', 'Sex', 'Sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Sep', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar'
  });

  locale('pt-BR');

  function handleThemeChange() {
    if (systemConfig.theme === "light") {
      update({ ...systemConfig, theme: "dark" })
    } else {
      update({ ...systemConfig, theme: "light" })
    }
  }

  function handleLangChange() {

    if (i18n.language === "pt-br") {
      i18n.changeLanguage('en')
    } else {
      i18n.changeLanguage('pt-br')
    }
  }

  return (
    <NotificationProvider>
      <ThemeProvider theme={systemConfig.theme === "light" ? lightTheme : darkTheme}>
        {/* <Col xs={12} className="d-flex justify-content-end p-1">
        {
          i18n.language === "pt-br" ? (
            <div className="emoji-content langChange" onClick={handleLangChange}>
              <div className="emoji">
              <img width="100%" height="100%" style={{ borderRadius: "6px" }} src="https://s1.static.brasilescola.uol.com.br/be/conteudo/images/2-bandeira-do-brasil.jpg" alt="Idioma: Português"/>
              </div>
            </div>
          ) : (
            <div className="emoji-content langChange" onClick={handleLangChange}>
              <div className="emoji">
              <img width="100%" height="100%" style={{ borderRadius: "6px" }} src="https://s1.1zoom.me/prev/571/USA_Flag_570873_600x400.jpg" alt="Idioma: Inglês"/>
              </div>
            </div>
          )
        }
        <Form.Check
          className="mt-1"
          type="switch"
          id="custom-switch"
          label="Tema Escuro"
          checked={systemConfig.theme === "dark"? true : false}
          onChange={() => handleThemeChange()}
        />
      </Col>  */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          theme={'colored'}
          closeOnClick
          pauseOnHover
        />
        <GlobalStyle />
        <Routes />
      </ThemeProvider>
    </NotificationProvider>

  );
}

export default App;
